/* eslint-disable no-console */
const addListeners = (options) => {
  const {
    stickyToggle,
    footerSelector,
    headerSelector,
    selector,
  } = options;
  const sidebar = document.querySelector(selector);
  const parent = sidebar.parentNode;
  const footer = document.querySelector(footerSelector);
  const header = document.querySelector(headerSelector);
  const paddingOffset = 26;
  const sidebarTopMargin = 10;

  const updateSidebarDims = () => {
    sidebar.style.maxHeight = `${window.innerHeight - (header.clientHeight + sidebarTopMargin)}px`;
    sidebar.style.width = `${parent.clientWidth - paddingOffset}px`;
  };

  const updateSidebarPosition = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const sidebarTop = sidebar.parentNode.getBoundingClientRect().top + scrollTop;
    // console.log(`(${sidebarTop}/${window.pageYOffset + header.clientHeight}), stickyToggle: ${sidebar.classList.contains(stickyToggle)}`);
    const footerTop = footer.getBoundingClientRect().top + scrollTop;
    // console.log(`(${footerTop - window.innerHeight}/${window.pageYOffset})`);
    if (footerTop - window.innerHeight <= window.pageYOffset) {
      sidebar.classList.remove(stickyToggle);
      sidebar.removeAttribute('style');
      sidebar.style.bottom = 0;
      return;
    }
    if (sidebarTop <= window.pageYOffset + header.clientHeight + sidebarTopMargin && sidebar.classList.contains(stickyToggle)) {
      return;
    }
    if (sidebarTop > window.pageYOffset + header.clientHeight + sidebarTopMargin && !sidebar.classList.contains(stickyToggle)) {
      return;
    }
    if (sidebarTop <= window.pageYOffset + header.clientHeight + sidebarTopMargin) {
      sidebar.classList.add(stickyToggle);
      sidebar.style.top = `${header.clientHeight + sidebarTopMargin}px`;
      updateSidebarDims();
    } else {
      sidebar.classList.remove(stickyToggle);
      sidebar.removeAttribute('style');
    }
  };

  window.addEventListener('scroll', () => {
    updateSidebarPosition();
  });

  window.addEventListener('resize', () => {
    updateSidebarPosition();
    updateSidebarDims();
  });

  updateSidebarPosition();
};

const init = (options) => {
  addListeners(options);
};

export default {
  init,
};
/* eslint-enable no-console */
